import { createTheme } from '@mui/material/styles';
import { palette } from './palette';
import { typography } from './typography';
import { components } from './components';
import { radius, shadows, transitions, spacing, colors } from './tokens';

const theme = createTheme({
    palette,
    typography,
    components,
    shape: { borderRadius: radius.md },
    // Custom keys — accessible via theme.customShadows etc.
    customShadows: shadows,
    customTransitions: transitions,
    customSpacing: spacing,
    customRadius: radius,
    customColors: colors,
});

export default theme;
